export default "__VITE_ASSET__CoVxtA70__"